import { priceListUrl } from "../Config/Url";
import axios from "axios";

export const priceListServices = {
  getById,
  getSearch,
  create,
  update,
  deletePriceList,
  copyPriceList,
};

async function getById(priceListId) {
  return axios
    .get(`${priceListUrl}/${priceListId}`)
    .then((res) => res)
    .catch((err) => err.response);
}

async function getSearch({ tenantId, searchName, pageIndex, pageSize }) {
  return axios
    .put(`${priceListUrl}/search`, {
      tenantId,
      searchName,
      pageIndex,
      pageSize,
    })
    .then((res) => res)
    .catch((err) => err.response);
}

async function create({ tenantId, name }) {
  return axios
    .post(`${priceListUrl}`, { tenantId, name })
    .then((res) => res)
    .catch((err) => err.response);
}

async function update({ priceListId, name }) {
  return axios
    .put(`${priceListUrl}/${priceListId}`, { name })
    .then((res) => res)
    .catch((err) => err.response);
}

async function deletePriceList(priceListId) {
  return axios
    .delete(`${priceListUrl}/${priceListId}`)
    .then((res) => res)
    .catch((err) => err.response);
}

async function copyPriceList({ copyFromPriceListId, copyToPriceListId }) {
  return axios
    .put(`${priceListUrl}/${copyToPriceListId}/copy`, {
      priceListCopyId: copyFromPriceListId,
    })
    .then((res) => res)
    .catch((err) => err.response);
}
